import { TESTIMONIALS } from "../../lib/content";

export const Testimonials = () => {
  const loop = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32 bg-[#0C1812] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-14">
        <span className="overline">In their words</span>
        <h2 className="font-serif-display text-[#FDFBF7] text-3xl md:text-5xl tracking-tight mt-4 leading-tight max-w-2xl">
          Owners who trust us, stay with us
        </h2>
      </div>

      <div className="relative">
        <div className="flex gap-6 w-max marquee-track">
          {loop.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="w-[400px] shrink-0 p-9 rounded-2xl bg-[#0F2119] border border-white/5"
            >
              <div className="font-serif-display text-[#D4AF37] text-5xl leading-none mb-4">“</div>
              <p className="font-serif-display italic text-[#FDFBF7] text-xl leading-relaxed">{t.quote}</p>
              <div className="mt-7 pt-5 border-t border-white/5">
                <div className="text-[#FDFBF7] font-semibold">{t.name}</div>
                <div className="text-[#A3B1A8] text-sm">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0C1812] to-transparent pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0C1812] to-transparent pointer-events-none" />
      </div>
    </section>
  );
};
